import axios from 'axios';
import * as actionTypes from './types';

export const setSalesforceProducts = (products) => ({
  type: actionTypes.SET_SALESFORCE_PRODUCTS,
  products,
});

export const loadSalesforceProducts = () => async (dispatch) => {
  const result = await axios.get('/api/salesforce-product');
  if (result.data.products) {
    dispatch(setSalesforceProducts(result.data.products));
  }
};
